import React, { createRef } from 'react'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import Header from '../../Header'
import Footer from '../../Footer'
import { Numpad } from '../../Numpad'
import { FormField } from '../../FormField'
import { getReservationByNumberAndDriversBirthday, clearReservationAction } from '../../../actions'
import { setReservationIdAction, setDriver1BirthDateAction } from '../../../actions/'
import { AppState } from '../../../reducers'
import { validateLength, validateShortBirthDate, validateForToday, getMobileFormattedDate } from '../../DateInput'
import CustomCaret, { CustomCaretProps } from '../../CustomCaret'
import './home.less'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'
import { setSessionGuid } from '../../../actions/api'
import { validateKeyboardInput } from '../../../utilities/inputValidation'

const mapDispatchToProps = {
  clearReservation: clearReservationAction,
  setReservationId: setReservationIdAction,
  setDriver1BirthDate: setDriver1BirthDateAction,
  getReservationByNumberAndDriversBirthday,
}
type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  resId: state.reservationChange.resId,
  driverBirthDate: state.reservation.birthDate,
})

type StateProps = ReturnType<typeof mapStateToProps>

interface ComponentState {
  activeInput?: HTMLInputElement | null
  format?: string
  max?: number
  mode?: MODE
  driverBirthDateMobileCursorPosition: number
  resIdMobileCursorPosition: number
  isResIdWrongTyping: boolean
  isBirthDateWrongTyping: boolean
}

class Home extends React.PureComponent<DispatchProps & StateProps & WithTranslation, ComponentState> {
  state = {
    activeInput: undefined,
    format: undefined,
    max: 8,
    mode: undefined,
    driverBirthDateMobileCursorPosition: 0,
    resIdMobileCursorPosition: 0,
    isResIdWrongTyping: false,
    isBirthDateWrongTyping: false,
  }
  private driverBirthDateInput = createRef<HTMLInputElement>()
  private resIdInput = createRef<HTMLInputElement>()
  resId: any
  private refResCaret = createRef<CustomCaretProps>()
  private refDateCaret = createRef<CustomCaretProps>()

  componentDidMount() {
    const mode = getMode()
    this.props.clearReservation()
    this.setState({ activeInput: this.resIdInput.current, mode })
    this.props.setReservationId('')
    this.props.setDriver1BirthDate('')
    if (mode === MODE.KIOSK) {
      setSessionGuid('')
    }
  }

  componentDidUpdate() {
    if (this.state.mode === MODE.KIOSK) {
      return
    }
    if (this.driverBirthDateInput.current && this.state.activeInput === this.driverBirthDateInput.current) {
      //@ts-ignore
      this.driverBirthDateInput.current.setSelectionRange(this.state.driverBirthDateMobileCursorPosition, this.state.driverBirthDateMobileCursorPosition)
    } else if (this.resIdInput.current && this.state.activeInput === this.resIdInput.current) {
      //@ts-ignore
      this.resIdInput.current.setSelectionRange(this.state.resIdMobileCursorPosition, this.state.resIdMobileCursorPosition)
    }
  }

  getReservation = () => {
    const { resId, driverBirthDate, getReservationByNumberAndDriversBirthday } = this.props
    if (resId && driverBirthDate) {
      getReservationByNumberAndDriversBirthday(resId, driverBirthDate)
    }
  }
  onChange = (value: string) => {
    const { max, activeInput } = this.state
    const { setReservationId, setDriver1BirthDate } = this.props
    if (activeInput === this.driverBirthDateInput.current) {
      if (value.length <= max) {
        setDriver1BirthDate(value)
      } else {
        this.forceUpdate()
      }
    } else if (activeInput === this.resIdInput.current) {
      if (value.length <= max) {
        setReservationId(value)
      } else {
        // @ts-ignore
        this.resIdInput.current.value = value.slice(0, max)
        this.forceUpdate()
      }
    }
    this.updateCaretPosition()
  }

  onChangeFromKeyboard = (target: HTMLInputElement) => {
    const value = target.value
    const { max, activeInput } = this.state
    const { setReservationId, setDriver1BirthDate } = this.props
    this.setState({ isResIdWrongTyping: false, isBirthDateWrongTyping: false })

    if (activeInput === this.driverBirthDateInput.current) {
      const removedDotsAndSpaces = value.replace(/[. ]/g, '')
      const isValid = validateKeyboardInput(removedDotsAndSpaces, { numeric: true })
      if (!isValid) {
        this.setState({ isBirthDateWrongTyping: true, driverBirthDateMobileCursorPosition: target.selectionStart ? target.selectionStart - 1 : 0 })
        return this.forceUpdate()
      }
      const data = getMobileFormattedDate(this.driverBirthDateInput.current, value, max)
      if ((value.length <= max + 1) && !!data) {
        this.setState({ driverBirthDateMobileCursorPosition: data.cursorPosition })
        setDriver1BirthDate(data.value)
      } else {
        this.forceUpdate()
      }
    } else if (activeInput === this.resIdInput.current) {
      const isValid = validateKeyboardInput(value, { numeric: true })
      if (!isValid) {
        this.setState({ isResIdWrongTyping: true , resIdMobileCursorPosition: target.selectionStart ? target.selectionStart - 1 : 0 })
        return this.forceUpdate()
      }
      if (value.length <= max) {
        setReservationId(value)
        //@ts-ignore
        this.setState({ resIdMobileCursorPosition: this.resIdInput.current.selectionStart })
      } else {
        // @ts-ignore
        this.resIdInput.current.value = value.slice(0, max)
        this.forceUpdate()
      }
    }
  }

  onKeyboardDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode !== 13 || !(this.driverBirthDateInput && this.driverBirthDateInput.current)) {
      return
    }

    if (this.state.activeInput === this.resIdInput.current) {
      this.driverBirthDateInput.current.focus()
    } else {
      this.getReservation()
    }
  }

  checkAndShowPlaceholderDOB = () => {
    const { driverBirthDate, setDriver1BirthDate } = this.props
    driverBirthDate === '  .  .  ' && setDriver1BirthDate('')
  }
  updateCaretPosition = () => {
    const { activeInput } = this.state
    if (activeInput === this.driverBirthDateInput.current) {
      this.refDateCaret.current && this.refDateCaret.current.updateCaretPosition()
    } else if (activeInput === this.resIdInput.current) {
      this.refResCaret.current && this.refResCaret.current.updateCaretPosition()
    }
  }
  render() {
    const { resId = '', driverBirthDate = '' } = this.props
    const isDateFieldError = !validateShortBirthDate(driverBirthDate) && validateLength(driverBirthDate, 8)
    const isDateTodayError = !validateForToday(driverBirthDate)
    const isInputError =
      !validateShortBirthDate(driverBirthDate) ||
      !validateLength(resId, 8) ||
      !validateLength(driverBirthDate, 8) ||
      !String(resId).trim()
    const dateFieldInputStyle = isDateFieldError ? 'date-field-input error-input' : 'date-field-input'

    if (this.state.mode === MODE.MOBILE) {
      return this.renderMobile(isDateTodayError, isDateFieldError, isInputError, dateFieldInputStyle)
    }

    if (this.state.mode === MODE.DESKTOP) {
      return this.renderDesktop(isDateTodayError, isDateFieldError, isInputError, dateFieldInputStyle)
    }

    return this.renderKiosk(isDateTodayError, isDateFieldError, isInputError, dateFieldInputStyle)

  }

  renderMobile(isDateTodayError: boolean, isDateFieldError: boolean, isInputError: boolean, dateFieldInputStyle: "date-field-input error-input" | "date-field-input") {
    const { t, resId = '', driverBirthDate = '' } = this.props
    const { isResIdWrongTyping, isBirthDateWrongTyping } = this.state
    const getBirthDateSubLabel = () => {
      if (isBirthDateWrongTyping) {
        return t('typeNumbersOnly')
      } else if (!isDateFieldError) {
        return t('homeExample') + ': 01.01.90'
      } else if (isDateTodayError) {
        return t('alreadyCheckedInIncorrectDOB')
      } else {
        return t('homeEnterDateInFormat')
      }
    }
    return (
      <div className="home-mobile">
        <div className="main">
          <div className="main-container">
            <div className="home-title" dangerouslySetInnerHTML={{ __html: t('homeCheckIn') }}></div>
            <FormField id="home-res-id-input" label={t('homeBookingNumber')} sublabel={isResIdWrongTyping ? t('typeNumbersOnly') : ''} isError={isResIdWrongTyping}>
              <div className="input-field-cont">
                <div className="overlay">
                  <div className="input-background">
                    <div className="input-background-fields" />
                    <div className="input-background-fields" />
                    <div className="input-background-fields" />
                    <div className="input-background-fields" />
                    <div className="input-background-fields" />
                    <div className="input-background-fields" />
                    <div className="input-background-fields" />
                    <div className="input-background-fields without-border" />
                  </div>
                </div>
                <input
                  inputMode='numeric'
                  ref={this.resIdInput}
                  value={resId}
                  className="booking-field-input"
                  onChange={(e) => this.onChangeFromKeyboard(e.target)}
                  onFocus={() => {
                    this.checkAndShowPlaceholderDOB()
                    this.setState({
                      activeInput: this.resIdInput.current,
                      format: 'number',
                      max: 8,
                    })
                  }}
                  onKeyDown={this.onKeyboardDown}
                />
              </div>
            </FormField>
            <FormField
              id="home-driver-birth-input"
              label={t('homeDriversDateOfBirth')}
              classFormField="form-field-mobile sub-label-absolute form-field-birth-date"
              isError={isDateFieldError || isBirthDateWrongTyping ? true : false}
              sublabel={getBirthDateSubLabel()}
            >
              <>
                <input
                  inputMode='numeric'
                  ref={this.driverBirthDateInput}
                  className={dateFieldInputStyle}
                  placeholder={t('datePlaceholderShort')}
                  value={driverBirthDate}
                  onFocus={() => {
                    this.setState({ activeInput: this.driverBirthDateInput.current, format: 'date', max: 8 })
                  }}
                  onChange={(e) => this.onChangeFromKeyboard(e.target)}
                  onKeyDown={!isInputError ? this.onKeyboardDown : undefined}
                />
              </>
            </FormField>
            <button className="main-button" onClick={this.getReservation} disabled={isInputError ? true : false}>
              {t('ok')}
            </button>
          </div>
        </div>
        <div className="footer-mobile-container">
          <FooterMobile />
        </div>
      </div>
    )
  }

  renderDesktop(isDateTodayError: boolean, isDateFieldError: boolean, isInputError: boolean, dateFieldInputStyle: "date-field-input error-input" | "date-field-input") {
    const { t, resId = '', driverBirthDate = '' } = this.props
    const { isResIdWrongTyping, isBirthDateWrongTyping } = this.state
    const getBirthDateSubLabel = () => {
      if (isBirthDateWrongTyping) {
        return t('typeNumbersOnly')
      } else if (!isDateFieldError) {
        return t('homeExample') + ': 01.01.90'
      } else if (isDateTodayError) {
        return t('alreadyCheckedInIncorrectDOB')
      } else {
        return t('homeEnterDateInFormat')
      }
    }
    return (
      <div className="home-desktop">
        <Header showTimer />
        <div className="main-container">
          <div className="main">
            <div className="main-wrapper">
              <div className="home-title" dangerouslySetInnerHTML={{ __html: t('homeCheckIn') }}></div>
              <FormField id="home-res-id-input" label={t('homeBookingNumber')} sublabel={isResIdWrongTyping ? t('typeNumbersOnly') : ''} isError={isResIdWrongTyping}>
                <div className="input-field-cont">
                  <div className="overlay">
                    <div className="input-background">
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields without-border" />
                    </div>
                  </div>
                  <input
                    autoFocus
                    ref={this.resIdInput}
                    value={resId}
                    className="booking-field-input"
                    onChange={(e) => this.onChangeFromKeyboard(e.target)}
                    onFocus={() => {
                      this.checkAndShowPlaceholderDOB()
                      this.setState({
                        activeInput: this.resIdInput.current,
                        format: 'number',
                        max: 8,
                      })
                    }}
                    onKeyDown={this.onKeyboardDown}
                  />
                </div>
              </FormField>
              <FormField
                id="home-driver-birth-input"
                label={t('homeDriversDateOfBirth')}
                classFormField="form-field show-cursor sub-label-absolute form-field-birth-date"
                isError={isDateFieldError || isBirthDateWrongTyping ? true : false}
                sublabel={getBirthDateSubLabel()}
              >
                <input
                  ref={this.driverBirthDateInput}
                  className={dateFieldInputStyle}
                  placeholder={t('datePlaceholderShort')}
                  value={driverBirthDate}
                  onFocus={() => {
                    this.setState({ activeInput: this.driverBirthDateInput.current, format: 'date', max: 8 })
                  }}
                  onChange={(e) => this.onChangeFromKeyboard(e.target)}
                  onKeyDown={!isInputError ? this.onKeyboardDown : undefined}
                />
              </FormField>
              <button className="main-button" onClick={this.getReservation} disabled={isInputError ? true : false}>
                {t('ok')}
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  renderKiosk(isDateTodayError: boolean, isDateFieldError: boolean, isInputError: boolean, dateFieldInputStyle: "date-field-input error-input" | "date-field-input") {
    const { t, resId = '', driverBirthDate = '' } = this.props
    return (
      <div className="home">
        <Header showTimer />
        <div className="main-container">
          <div className="main">
            <div className="main-wrapper">
              <div className="home-title" dangerouslySetInnerHTML={{ __html: t('homeCheckIn') }}></div>
              <FormField id="home-res-id-input" label={t('homeBookingNumber')}>
                <div className="input-field-cont">
                  <div className="overlay">
                    <div className="input-background">
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields" />
                      <div className="input-background-fields without-border" />
                    </div>
                  </div>
                  <input
                    autoFocus
                    ref={this.resIdInput}
                    value={resId}
                    className="booking-field-input"
                    onChange={(e) => this.onChange(e.target.value)}
                    onFocus={() => {
                      this.checkAndShowPlaceholderDOB()
                      this.setState({
                        activeInput: this.resIdInput.current,
                        format: 'number',
                        max: 8,
                      })
                    }}
                    onClick={() => this.updateCaretPosition()}
                  />
                  <CustomCaret ref={this.refResCaret} inputRef={this.resIdInput.current} />
                </div>
              </FormField>
              <FormField
                id="home-driver-birth-input"
                label={t('homeDriversDateOfBirth')}
                classFormField="form-field sub-label-absolute form-field-birth-date"
                isError={isDateFieldError ? true : false}
                sublabel={
                  !isDateFieldError
                    ? t('homeExample') + ': 01.01.90'
                    : isDateTodayError
                      ? t('alreadyCheckedInIncorrectDOB')
                      : t('homeEnterDateInFormat')
                }
              >
                <>
                  <input
                    ref={this.driverBirthDateInput}
                    className={dateFieldInputStyle}
                    placeholder={t('datePlaceholderShort')}
                    value={driverBirthDate}
                    onFocus={() => {
                      this.setState({ activeInput: this.driverBirthDateInput.current, format: 'date' })
                    }}
                    onChange={(e) => this.onChange(e.target.value)}
                    onClick={() => this.updateCaretPosition()}
                  />
                  <CustomCaret ref={this.refDateCaret} inputRef={this.driverBirthDateInput.current} />
                </>
              </FormField>
              <button className="main-button" onClick={this.getReservation} disabled={isInputError ? true : false}>
                {t('ok')}
              </button>
            </div>
          </div>
          <div className="numpad-container">
            <Numpad input={this.state.activeInput} onChange={this.onChange} format={this.state.format} />
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Home))
